import { initializeApp } from "firebase/app";

///import


import {
  deleteObject,
  getDownloadURL,
  getStorage,
  ref,
  uploadString,
} from "firebase/storage";

import Compress from "compress.js";

export default class Firebase {
  constructor() {
    this._config = {
      apiKey: "AIzaSyDltxj3HeiIYjzElxaIoA8pXveOBEewfhM",
      authDomain: "sisfrota-138a0.firebaseapp.com",
      projectId: "sisfrota-138a0",
      storageBucket: "sisfrota-138a0.appspot.com",
      messagingSenderId: "52666684067",
      appId: "1:52666684067:web:6dbd6d2eb0f24f7174e516",
      measurementId: "G-97WGT4RFRC"
      /*
      apiKey: "AIzaSyDoH_jCaiJFkKYYn8NVyApPn2eUpq7_MLE",
      authDomain: "covid-d35a5.firebaseapp.com",
      projectId: "covid-d35a5",
      storageBucket: "covid-d35a5.appspot.com",
      messagingSenderId: "208889059885",
      appId: "1:208889059885:web:e2640ab53c9ea743db76a4",
      measurementId: "G-LMCMM1KSM8"
      */
    };

    this.init();
    this.compress = new Compress();
  }

  init() {
    if (!window._initializedFirebase) {
      this.firebase = initializeApp(this._config);
      window._initializedFirebase = true;
    }
  }

  static hd() {
    return getStorage();
  }

  onSelect(obj) {
    return new Promise((resolve, reject) => {
      //Capturando objeto
      let arquivo = {
        base64: "",
        type: null,
      };
      let file = obj.files[0];
      let fileReader = new FileReader();
      //Capiturando Base64 do objeto
      fileReader.onload = () => {
        arquivo.base64 = fileReader.result;
      };
      fileReader.readAsDataURL(file);

      //APLICANDO O COMPRESS
      if (file.type.startsWith("image/")) {
        this.compress
          .compress([file], {
            size: 2,
            quality: 0.75,
            maxWidth: 1920,
            maxHeight: 1920,
            resize: true,
          })
          .then((data) => {
            let arquivoComprimido = data[0];
            arquivo.base64 = `${arquivoComprimido.prefix}${arquivoComprimido.data}`;
            resolve(arquivo);
          })
          .catch((error) => {
            console.error("Error " + error);
            reject("Não foi possível ler o arquivo!");
          });
      } else {
        resolve(arquivo);
      }
    });
  }

  onUpload(file, from) {
    return new Promise((resolve, reject) => {
      const storeRef = ref(Firebase.hd(), from);
      uploadString(storeRef, file.base64, "data_url")
        .then((snapshot) => {
          getDownloadURL(snapshot.ref).then((downloadURL) => {
            resolve(downloadURL);
          });
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  onUpdate(file, from, url) {
    return new Promise((resolve, reject) => {
      this.onDeleteByURL(url)
        .then(() => {
          this.onUpload(file, from)
            .then((downloadURL) => {
              resolve(downloadURL);
            })
            .catch((err) => {
              console.error(err);
              reject("Não foi possível atualizar a imagem");
            });
        })
        .catch((err) => {
          console.error(err);
          reject("Não foi possível excluir a imagem");
        });
    });
  }

  onDelete(from) {
    return new Promise((resolve, reject) => {
      deleteObject(ref(Firebase.hd(), from))
        .then(() => {
          resolve();
        })
        .catch((error) => {
          //console.log(error)
          //console.err(err);
          reject("Não foi possível deletar a imagem" + error);
        });
    });


  }

  onDeleteByURL(url) {
    return new Promise((resolve, reject) => {
      deleteObject(ref(Firebase.hd(), url))
        .then(() => {
          resolve();
        })
        .catch((err) => {
          console.err(err);
          reject("Não foi possível deletar a imagem");
        });
    });
  }
}
